/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_MarcaCarga as MarcaCarga,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_api as api,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function FormularioSolicitante({
  editar: e,
  sedes: t,
  areas: n,
  onClose: r,
  onGuardado: i,
}) {
  let [a, o] = (0, React.useState)(e?.nombre ?? ``),
    [s, c] = (0, React.useState)(e?.telefono ?? ``),
    [l, u] = (0, React.useState)(!e || e.activo),
    f = (e, t) => {
      let n = (t ?? ``).split(`, `).filter(Boolean);
      return e.filter((e) => n.includes(e.nombre)).map((e) => e.id);
    },
    [p, m] = (0, React.useState)(() => f(t, e?.sedes)),
    [h, g] = (0, React.useState)(() => f(n, e?.areas)),
    [_, v] = (0, React.useState)(``),
    [y, b] = (0, React.useState)(!1),
    // Sede (Ica / Pisco) de cada fundo, del maestro Fundos (2026-10-08).
    [sedeDe, setSedeDe] = (0, React.useState)({});
  (0, React.useEffect)(() => {
    api(`/fundos`)
      .then((fs) => setSedeDe(Object.fromEntries((fs ?? []).map((f) => [String(f.nombre).trim().toUpperCase(), f.sedeNombre || `Sin sede`]))))
      .catch(() => {});
  }, []);
  const grupos = (() => {
    const m = new Map();
    for (const f of t) {
      const g = sedeDe[String(f.nombre).trim().toUpperCase()] ?? `Sin sede`;
      if (!m.has(g)) m.set(g, []);
      m.get(g).push(f);
    }
    return [...m.entries()].sort((a, b) => (a[0] === `Sin sede`) - (b[0] === `Sin sede`) || a[0].localeCompare(b[0]));
  })();
  function x(e) {
    m((t) => (t.includes(e) ? t.filter((t) => t !== e) : [...t, e]));
  }
  function S(e) {
    g((t) => (t.includes(e) ? t.filter((t) => t !== e) : [...t, e]));
  }
  async function C(t) {
    if ((t.preventDefault(), !y)) {
      (b(!0), v(``));
      try {
        (await api(`/transporte/numeros`, {
          method: `POST`,
          body: JSON.stringify({
            id: e?.id ?? null,
            nombre: a,
            telefono: s,
            activo: l,
            sedes: p,
            areas: h,
          }),
        }),
          i());
      } catch (e) {
        v(e.message);
      } finally {
        b(!1);
      }
    }
  }
  return (
    <Modal
      titulo={e ? e.nombre : `Nueva persona`}
      onClose={r}
      children={
        <form
          onSubmit={C}
          className={`flex flex-col gap-3`}
          children={[
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Nombre`,
                <input
                  autoFocus={!0}
                  value={a}
                  onChange={(e) => o(e.target.value)}
                  className={Lo}
                />,
              ]}
            />,
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Número de WhatsApp`,
                <input
                  value={s}
                  onChange={(e) => c(e.target.value)}
                  placeholder={`51999888777`}
                  inputMode={`numeric`}
                  className={Lo}
                />,
              ]}
            />,
            <p
              className={`-mt-2 text-xs text-(--text)`}
              children={`Con el código del país y sin espacios. Si no coincide, esa persona escribe y no recibe respuesta.`}
            />,
            <div
              className={`flex flex-col gap-2`}
              children={[
                <p
                  className={`text-sm text-(--text)`}
                  children={`Desde qué fundos puede pedir`}
                />,
                ...grupos.map(([sede, fundos]) => (
                  <div key={sede} className={`flex flex-col gap-1.5`}>
                    <span className={`text-xs font-medium uppercase tracking-wide text-(--text)`}>{grupos.length > 1 || sede !== `Sin sede` ? `Sede ${sede}` : ``}</span>
                    <div className={`flex flex-wrap gap-x-4 gap-y-2`}>
                      {fundos.map((e) => (
                        <MarcaCarga key={e.id} checked={p.includes(e.id)} onChange={() => x(e.id)} children={e.nombre} />
                      ))}
                    </div>
                  </div>
                )),
                p.length === 0 && (
                  <p
                    className={`text-xs text-(--warning)`}
                    children={`Sin ningún fundo no va a poder pedir.`}
                  />
                ),
              ]}
            />,
            <div
              className={`flex flex-col gap-2`}
              children={[
                <p
                  className={`text-sm text-(--text)`}
                  children={`Para qué áreas puede pedir`}
                />,
                <div
                  className={`flex flex-wrap gap-x-4 gap-y-2`}
                  children={n.map((e) => (
                    <MarcaCarga
                      key={e.id}
                      checked={h.includes(e.id)}
                      onChange={() => S(e.id)}
                      children={e.nombre}
                    />
                  ))}
                />,
                <p
                  className={`text-xs text-(--text)`}
                  children={
                    h.length === 0
                      ? `Sin marcar ninguna, puede pedir para cualquier área.`
                      : h.length === 1
                        ? `Con una sola, no se le pregunta: se usa esa.`
                        : `Se le va a preguntar cuál de estas al hacer el pedido.`
                  }
                />,
              ]}
            />,
            e && (
              <div
                className={`border-t border-(--border) pt-3`}
                children={
                  <MarcaCarga
                    checked={l}
                    onChange={u}
                    children={`Puede pedir movilidad`}
                  />
                }
              />
            ),
            _ && <p className={`text-sm text-(--error)`} children={_} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={r}
                  className={zo}
                  children={`Cancelar`}
                />,
                <button
                  type={`submit`}
                  disabled={y}
                  className={Ro}
                  children={y ? `Guardando…` : `Guardar`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
